import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

const MisconfiguredGameWarning = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const img_recommendations = props?.img_recommendations ?? false;
	const icon = props?.icon ?? 'knk-alert';
	const autotranslate = props?.autotranslate ?? true;

	let message = props?.message ?? "Missing configuration";
	if(autotranslate) message = i18n(message);

	const classes = ['game_with_error', 'not_awesome'];
	if(icon !== false) classes.push(icon);

	return (
		<div class={classes.join(" ")}>
			<strong>{message}.</strong>

			{(img_recommendations !== false) && (
				<span class="size_recommendation">
					<FormattedMessage
						id="Recommended size: {w}×{h}px"
						values={img_recommendations}
					/>.
				</span>
			)}
		</div>
	)
};

export default injectIntl(MisconfiguredGameWarning);